export default "__VITE_ASSET__O8pMi3dL__"